import mobileMenuButtons from './mobile-menu';
import mainHeaderSearch from './main-header-search';


mobileMenuButtons();

document.addEventListener("DOMContentLoaded", function() {
    mainHeaderSearch();

    // from ready.js
    function customScrollMenu() {
        const $primaryNavigationSubmenus = jQuery('.nav-inner').find('.sub-menu');

        if (window.matchMedia('(max-width: 1024px)').matches) {
            $primaryNavigationSubmenus.mCustomScrollbar('destroy');
        } else {
            $primaryNavigationSubmenus.mCustomScrollbar();
        }
    }

    customScrollMenu();

    window.addEventListener("resize", customScrollMenu, passiveIfSupported);
});
